// 通用主体顶部组件
const AppHeader_Navs_copy = () => import("../../layout/AppHeader_Navs_copy");
// 当前路由组件
const buyerCenter = () => import('../../views/buyerCenter/index');
// 通用顶部条组件
const topbar = () => import("../../layout/topbar");
// 通用主体头部组件
const AppHeader_main = () => import("../../layout/AppHeader_main");
export default [{
	path: "/buyerCenter",
	name: "buyerCenter",
	components: {
		//  topbar: topbar,
		// header: AppHeader_Nav, 
		header: AppHeader_Navs_copy,//AppHeader_Nav 顶部主体样式 || AppHeader_main 头部主体样式

		default: buyerCenter
	},
	meta: {
		requireAuth: true // 需要验证登录状态
	},
	props: {
		header: {
			type: '1',//根据不同类型切入组件判断逻辑
		}
	},
}
]